var _rect, _rect2, _text, _text2, _rect3, _text3, _text4, _rect4, _text5, _text6, _text7, _text8, _text9, _text0, _rect5, _text1, _circle, _text10, _rect6, _text11, _rect7, _text12, _rect8, _text13, _circle2, _text14, _rect9, _text15, _rect0, _text16, _rect1, _text17, _circle3, _text18, _rect10, _text19, _rect11, _text20, _rect12, _text21, _circle4, _text22, _rect13, _text23, _rect14, _text24, _rect15, _text25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalentlenzRankedShortlistDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 760,
    height: 400,
    viewBox: "0 0 760 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TalentLenz ranked shortlist dashboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 758,
    height: 398,
    rx: 26,
    fill: "#FFFFFF",
    stroke: "#C8DCF3",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 24,
    width: 708,
    height: 88,
    rx: 17,
    fill: "#07152A"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 54,
    fill: "#80C4FF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5,
    fontWeight: 800,
    letterSpacing: 1.5
  }, "ILLUSTRATIVE OPPORTUNITY")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 83,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 21,
    fontWeight: 800
  }, "Operations Analyst")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 523,
    y: 39,
    width: 86,
    height: 57,
    rx: 13,
    fill: "#0D284A"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 566,
    y: 61,
    textAnchor: "middle",
    fill: "#80C4FF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 760
  }, "APPLICANTS")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 566,
    y: 85,
    textAnchor: "middle",
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 20,
    fontWeight: 820
  }, "1,247")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 39,
    width: 91,
    height: 57,
    rx: 13,
    fill: "#32142A"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 665.5,
    y: 61,
    textAnchor: "middle",
    fill: "#FF85B2",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 760
  }, "REVIEW SET")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 665.5,
    y: 85,
    textAnchor: "middle",
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 20,
    fontWeight: 820
  }, "32")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 133,
    fill: "#667A94",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5,
    fontWeight: 780
  }, "RANK")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 119,
    y: 133,
    fill: "#667A94",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5,
    fontWeight: 780
  }, "APPLICANT")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 407,
    y: 133,
    fill: "#667A94",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5,
    fontWeight: 780
  }, "SUITABILITY")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 618,
    y: 133,
    fill: "#667A94",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5,
    fontWeight: 780
  }, "HR STATUS")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 146,
    width: 708,
    height: 46,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#D7E4F2"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 175,
    fill: "#FF3885",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 820
  }, "01")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 169,
    r: 13,
    fill: "#FFF0F6"
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 119,
    y: 175,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 740
  }, "Applicant 0427")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 407,
    y: 159,
    width: 129.04999999999998,
    height: 9,
    rx: 4.5,
    fill: "#FF85B2"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 560,
    y: 175,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "89")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 618,
    y: 156,
    width: 94,
    height: 26,
    rx: 13,
    fill: "#E8F5FF"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 665,
    y: 173,
    textAnchor: "middle",
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 780
  }, "ADVANCE")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 203,
    width: 708,
    height: 46,
    rx: 12,
    fill: "#F8FBFF",
    stroke: "#D7E4F2"
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 232,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 820
  }, "02")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 226,
    r: 13,
    fill: "#EAF4FF"
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 119,
    y: 232,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 740
  }, "Applicant 0931")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 407,
    y: 216,
    width: 124.7,
    height: 9,
    rx: 4.5,
    fill: "#80C4FF"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 560,
    y: 232,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "86")), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 618,
    y: 213,
    width: 94,
    height: 26,
    rx: 13,
    fill: "#E8F5FF"
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 665,
    y: 230,
    textAnchor: "middle",
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 780
  }, "ADVANCE")), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 260,
    width: 708,
    height: 46,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#D7E4F2"
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 289,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 820
  }, "03")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 283,
    r: 13,
    fill: "#EAF4FF"
  })), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 119,
    y: 289,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 740
  }, "Applicant 0178")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 407,
    y: 273,
    width: 118.89999999999999,
    height: 9,
    rx: 4.5,
    fill: "#80C4FF"
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 560,
    y: 289,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "82")), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 618,
    y: 270,
    width: 94,
    height: 26,
    rx: 13,
    fill: "#FFF2F7"
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 665,
    y: 287,
    textAnchor: "middle",
    fill: "#C62F69",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 780
  }, "REVIEW")), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 317,
    width: 708,
    height: 46,
    rx: 12,
    fill: "#F8FBFF",
    stroke: "#D7E4F2"
  })), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 346,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 820
  }, "04")), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 340,
    r: 13,
    fill: "#EAF4FF"
  })), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 119,
    y: 346,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 740
  }, "Applicant 1104")), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 407,
    y: 330,
    width: 114.55,
    height: 9,
    rx: 4.5,
    fill: "#80C4FF"
  })), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 560,
    y: 346,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "79")), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 618,
    y: 327,
    width: 94,
    height: 26,
    rx: 13,
    fill: "#FFF2F7"
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 665,
    y: 344,
    textAnchor: "middle",
    fill: "#C62F69",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 780
  }, "REVIEW")), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 374,
    width: 708,
    height: 1,
    fill: "#D8E4F1"
  })), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 391,
    fill: "#667A94",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 9.5
  }, "Scores support review; HR controls progression decisions.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentlenzRankedShortlistDashboard);
export default __webpack_public_path__ + "static/media/talentlenz-ranked-shortlist-dashboard.36464c7e1557005ffb960d29998dfff9.svg";
export { ForwardRef as ReactComponent };